<mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>
  <!-- Step 1: General Information -->
  <mat-step label="I. Opći podaci o prijavitelju programa/projekta">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">I. Opći podaci o prijavitelju programa/projekta</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (generalInfoFieldValues.length > 0) {
          @for (field of generalInfoFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 2: Program / Project Information -->
  <mat-step label="II. Podaci o programu/projekta">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">II. Podaci o programu/projekta</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (programProjectFieldValues.length > 0) {
          @for (field of programProjectFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @default {
                        <!-- Special handling for enumerated fields -->
                        @if (field.property === 'category') {
                          {{ getCategoryLabel(field.value) }}
                        }
                        @if (field.property === 'area') {
                          {{ getAreaLabel(field.value) }}
                        }
                        @if (field.property !== 'category' && field.property !== 'area') {
                          {{ field.value }}
                        }
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 3: Visibility Information -->
  <mat-step label="III. Vidljivost programa/projekta">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">III. Vidljivost programa/projekta</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (visibilityFieldValues.length > 0) {
          @for (field of visibilityFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 4: Application Activities -->
  <mat-step label="IV. Aktivnosti">
    @if (application && application.activities && application.activities.length > 0) {
      @for (activity of application.activities; track activity; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Naziv aktivnosti:</strong> {{ activity.name }}</p>
              <p><strong>Opis aktivnosti:</strong> {{ activity.description }}</p>
              <p><strong>Rezultati:</strong> {{ activity.results }}</p>
              <p><strong>Datum početka:</strong> {{ activity.startDate | date:'d.M.yyyy.' }}</p>
              <p><strong>Datum završetka:</strong> {{ activity.endDate | date:'d.M.yyyy.' }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      }
    }
  </mat-step>

  <!-- Step 5: Budget Plan -->
  <mat-step label="V. Proračun">
    @if (application && application.budgetPlan) {
      <!-- Direct Costs -->
      <h3>POGLAVLJE A) IZRAVNI TROŠKOVI</h3>
      @for (budgetItem of directBudgetItems; track budgetItem; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Opis:</strong> {{ budgetItem.description }}</p>
              <p><strong>Iznos tražen od Općine:</strong> {{ budgetItem.amountRequested | currency:'EUR'  }}</p>
              <p><strong>Ukupan iznos troška:</strong> {{ budgetItem.totalAmount | currency:'EUR' }}</p>
              <p><strong>Objašnjenje proračunske stavke:</strong> {{ budgetItem.explanation }}</p>
              @if (budgetItemFileMap[budgetItem.id.toString()] && budgetItemFileMap[budgetItem.id.toString()].length > 0) {
                <p><strong>Dokumentacija:</strong></p>
                <ul>
                  @for (file of budgetItemFileMap[budgetItem.id.toString()]; track file) {
                    <li>
                      <a (click)="downloadFile(file)" class="download-link">
                        {{ file.name }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
      <div class="totals">
        <h4>Ukupno POGLAVLJE A) IZRAVNI TROŠKOVI (traženo / ukupno):
          {{ application.budgetPlan.totalDirectCostsRequested | currency:'EUR' }} / {{ application.budgetPlan.totalDirectCostsActual | currency:'EUR' }}
        </h4>
      </div>
      <!-- Indirect Costs -->
      <h3>POGLAVLJE B) NEIZRAVNI TROŠKOVI</h3>
      @for (budgetItem of indirectBudgetItems; track budgetItem; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Opis:</strong> {{ budgetItem.description  }}</p>
              <p><strong>Iznos tražen od Općine:</strong> {{ budgetItem.amountRequested | currency:'EUR' }}</p>
              <p><strong>Ukupan iznos troška:</strong> {{ budgetItem.totalAmount | currency:'EUR'  }}</p>
              <p><strong>Objašnjenje proračunske stavke:</strong> {{ budgetItem.explanation  }}</p>
              @if (budgetItemFileMap[budgetItem.id.toString()] && budgetItemFileMap[budgetItem.id.toString()].length > 0) {
                <p><strong>Dokumentacija:</strong></p>
                <ul>
                  @for (file of budgetItemFileMap[budgetItem.id.toString()]; track file) {
                    <li>
                      <a (click)="downloadFile(file)" class="download-link">
                        {{ file.name }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
      <div class="totals">
        <h4>Ukupno POGLAVLJE B) NEIZRAVNI TROŠKOVI (traženo / ukupno):
          {{ application.budgetPlan.totalIndirectCostsRequested | currency:'EUR' }} / {{ application.budgetPlan.totalIndirectCostsActual | currency:'EUR' }}
        </h4>
      </div>
      <!-- Total Costs -->
      <div class="totals">
        <h3>SVEUKUPNO (A + B) (traženo / ukupno):
          {{ application.budgetPlan.totalCostsRequested | currency:'EUR' }} / {{ application.budgetPlan.totalCostsActual | currency:'EUR' }}
        </h3>
      </div>
      <!-- Funding Sources -->
      <h3>OSTALI IZVORI FINANCIRANJA</h3>
      @for (fundingSource of application.budgetPlan.fundingSources; track fundingSource; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Vrsta izvora:</strong> {{ getFundingSourceTypeLabel(fundingSource.type) }}</p>
              <p><strong>Iznos:</strong> {{ fundingSource.amount | currency:'EUR' }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      }
      <!-- Total Funding from Other Sources -->
      <div class="totals">
        <h4>SVEUKUPNO (I + II + III + IV): {{ application.budgetPlan.totalFundingFromOtherSources | currency:'EUR' }}</h4>
      </div>
      <!-- Total Funding -->
      <div class="totals">
        <h3>SVEUKUPNI IZNOS TROŠKOVA PROGRAMA / PROJEKTA - SVI IZVORI: {{ application.budgetPlan.totalFunding | currency:'EUR' }}</h3>
      </div>
    }
  </mat-step>

  <!-- Step 6: Dokumenti -->
  <mat-step label="VI. Dokumenti">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">VI. Dokumenti</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (applicationFiles && applicationFiles.length > 0) {
          <p><strong>Priloženi dokumenti:</strong></p>
          <ul>
            @for (file of applicationFiles; track file) {
              <li>
                <a (click)="downloadFile(file)" class="download-link">
                  {{ file.name }}
                </a>
              </li>
            }
          </ul>
        } @else {
          <p>Nema dokumenata.</p>
        }

      </mat-card-content>
    </mat-card>
  </mat-step>
</mat-stepper>
